/**
 * RU-TICKCHG TC-11: a tick's day change for the ticker.
 *
 * The REST poll sends `change_pct: null` when it has no previous close; that is "no change known", shown as "—",
 * never as ▲ 0.00%. Returns { known: false } or { known: true, pct, up } (`pct` a finite number, 0 included).
 */
export function tickChange(tick) {
  const raw = tick?.change_pct;
  if (raw === null || raw === undefined || raw === "") return { known: false };
  const pct = Number(raw);
  if (!Number.isFinite(pct)) return { known: false };
  return { known: true, pct, up: pct >= 0 };
}
